import ModalCommon from "./Modal";

export default ModalCommon;
